import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "staging-banner",
  role: "status",
  "aria-label": "Staging environment notice"
}

import { onMounted, onUnmounted } from 'vue'
import { isStagingEnvironment } from '@/core/helpers/environment'

// Hostname is fixed for the lifetime of the page load, so evaluate once.
const BODY_CLASS = 'staging-env'

export default /*@__PURE__*/_defineComponent({
  __name: 'StagingBanner',
  setup(__props) {

const isStaging = isStagingEnvironment()

// Reserve space for the fixed banner by flagging <body>. The class is the single switch
// for the gated offset styles below; tying it to this component's lifecycle keeps the
// whole feature self-contained and leaves production rendering untouched (fails closed).
onMounted(() => {
  if (isStaging) document.body.classList.add(BODY_CLASS)
})
onUnmounted(() => {
  document.body.classList.remove(BODY_CLASS)
})

return (_ctx: any,_cache: any) => {
  return (_unref(isStaging))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "staging-banner__tag" }, [
          _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }),
          _createTextVNode(" STAGING ")
        ], -1),
        _createElementVNode("span", { class: "staging-banner__text" }, " STAGING ENVIRONMENT — do not enter real or production data. ", -1)
      ]))]))
    : _createCommentVNode("", true)
}
}

})